import type { LeadCreatePayload, CreateLeadResponse, ApiErrorResponse } from "./types";

const API_BASE = "/api";

/** Erreur levée par `createLead` quand l'API renvoie un statut non 2xx. */
export class ApiError extends Error {
  details?: Record<string, string[] | undefined>;

  constructor(message: string, details?: Record<string, string[] | undefined>) {
    super(message);
    this.name = "ApiError";
    this.details = details;
  }
}

/**
 * Envoie un lead au backend — payload complet (entreprise éligible) ou minimal (entreprise
 * inéligible, seulement email + consentement + réponses déjà connues). Lève `ApiError` si
 * la requête échoue.
 */
export async function createLead(payload: LeadCreatePayload): Promise<CreateLeadResponse> {
  const response = await fetch(`${API_BASE}/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = (await response.json()) as CreateLeadResponse | ApiErrorResponse;

  if (!response.ok) {
    const errData = data as ApiErrorResponse;
    throw new ApiError(errData.error ?? "Une erreur est survenue", errData.details);
  }

  return data as CreateLeadResponse;
}
